import { render, staticRenderFns } from "./ProductSalesRank.vue?vue&type=template&id=61b819a8&scoped=true&"
import script from "./ProductSalesRank.vue?vue&type=script&lang=js&"
export * from "./ProductSalesRank.vue?vue&type=script&lang=js&"
import style0 from "./ProductSalesRank.vue?vue&type=style&index=0&id=61b819a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b819a8",
  null
  
)

export default component.exports